import { render, staticRenderFns } from "./PaymentsToku.vue?vue&type=template&id=08f2b5c2&scoped=true&"
import script from "./PaymentsToku.vue?vue&type=script&lang=js&"
export * from "./PaymentsToku.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsToku.vue?vue&type=style&index=0&id=08f2b5c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2b5c2",
  null
  
)

export default component.exports